/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "երեկ",
        "-2": "նախանցյալ օրը",
        "0": "այսօր",
        "1": "վաղը",
        "2": "վաղը չէ մյուս օրը",
        "future": {
          "one": "{0} օրից",
          "other": "{0} օրից"
        },
        "past": {
          "one": "{0} օր առաջ",
          "other": "{0} օր առաջ"
        }
      },
      "day-narrow": {
        "-1": "երեկ",
        "-2": "երեկ չէ առաջի օրը",
        "0": "այսօր",
        "1": "վաղը",
        "2": "վաղը չէ մյուս օրը",
        "future": {
          "one": "{0} օրից",
          "other": "{0} օրից"
        },
        "past": {
          "one": "{0} օր առաջ",
          "other": "{0} օր առաջ"
        }
      },
      "day-short": {
        "-1": "երեկ",
        "-2": "երեկ չէ առաջի օրը",
        "0": "այսօր",
        "1": "վաղը",
        "2": "վաղը չէ մյուս օրը",
        "future": {
          "one": "{0} օրից",
          "other": "{0} օրից"
        },
        "past": {
          "one": "{0} օր առաջ",
          "other": "{0} օր առաջ"
        }
      },
      "hour": {
        "0": "այս ժամին",
        "future": {
          "one": "{0} ժամից",
          "other": "{0} ժամից"
        },
        "past": {
          "one": "{0} ժամ առաջ",
          "other": "{0} ժամ առաջ"
        }
      },
      "hour-narrow": {
        "0": "այս ժամին",
        "future": {
          "one": "{0} ժ-ից",
          "other": "{0} ժ-ից"
        },
        "past": {
          "one": "{0} ժ առաջ",
          "other": "{0} ժ առաջ"
        }
      },
      "hour-short": {
        "0": "այս ժամին",
        "future": {
          "one": "{0} ժ-ից",
          "other": "{0} ժ-ից"
        },
        "past": {
          "one": "{0} ժ առաջ",
          "other": "{0} ժ առաջ"
        }
      },
      "minute": {
        "0": "այս րոպեին",
        "future": {
          "one": "{0} րոպեից",
          "other": "{0} րոպեից"
        },
        "past": {
          "one": "{0} րոպե առաջ",
          "other": "{0} րոպե առաջ"
        }
      },
      "minute-narrow": {
        "0": "այս րոպեին",
        "future": {
          "one": "{0} ր-ից",
          "other": "{0} ր-ից"
        },
        "past": {
          "one": "{0} ր առաջ",
          "other": "{0} ր առաջ"
        }
      },
      "minute-short": {
        "0": "այս րոպեին",
        "future": {
          "one": "{0} ր-ից",
          "other": "{0} ր-ից"
        },
        "past": {
          "one": "{0} ր առաջ",
          "other": "{0} ր առաջ"
        }
      },
      "month": {
        "-1": "նախորդ ամիս",
        "0": "այս ամիս",
        "1": "հաջորդ ամիս",
        "future": {
          "one": "{0} ամսից",
          "other": "{0} ամսից"
        },
        "past": {
          "one": "{0} ամիս առաջ",
          "other": "{0} ամիս առաջ"
        }
      },
      "month-narrow": {
        "-1": "նախորդ ամիս",
        "0": "այս ամիս",
        "1": "հաջորդ ամիս",
        "future": {
          "one": "{0} ամսից",
          "other": "{0} ամսից"
        },
        "past": {
          "one": "{0} ամիս առաջ",
          "other": "{0} ամիս առաջ"
        }
      },
      "month-short": {
        "-1": "նախորդ ամիս",
        "0": "այս ամիս",
        "1": "հաջորդ ամիս",
        "future": {
          "one": "{0} ամսից",
          "other": "{0} ամսից"
        },
        "past": {
          "one": "{0} ամիս առաջ",
          "other": "{0} ամիս առաջ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "նախորդ եռամսյակ",
        "0": "այս եռամսյակ",
        "1": "հաջորդ եռամսյակ",
        "future": {
          "one": "{0} եռամսյակից",
          "other": "{0} եռամսյակից"
        },
        "past": {
          "one": "{0} եռամսյակ առաջ",
          "other": "{0} եռամսյակ առաջ"
        }
      },
      "quarter-narrow": {
        "-1": "նախորդ եռամսյակ",
        "0": "այս եռամսյակ",
        "1": "հաջորդ եռամսյակ",
        "future": {
          "one": "{0} եռմս-ից",
          "other": "{0} եռմս-ից"
        },
        "past": {
          "one": "{0} եռմս առաջ",
          "other": "{0} եռմս առաջ"
        }
      },
      "quarter-short": {
        "-1": "նախորդ եռամսյակ",
        "0": "այս եռամսյակ",
        "1": "հաջորդ եռամսյակ",
        "future": {
          "one": "{0} եռմս-ից",
          "other": "{0} եռմս-ից"
        },
        "past": {
          "one": "{0} եռմս առաջ",
          "other": "{0} եռմս առաջ"
        }
      },
      "second": {
        "0": "հիմա",
        "future": {
          "one": "{0} վայրկյանից",
          "other": "{0} վայրկյանից"
        },
        "past": {
          "one": "{0} վայրկյան առաջ",
          "other": "{0} վայրկյան առաջ"
        }
      },
      "second-narrow": {
        "0": "հիմա",
        "future": {
          "one": "{0} վ-ից",
          "other": "{0} վ-ից"
        },
        "past": {
          "one": "{0} վ առաջ",
          "other": "{0} վ առաջ"
        }
      },
      "second-short": {
        "0": "հիմա",
        "future": {
          "one": "{0} վրկ-ից",
          "other": "{0} վրկ-ից"
        },
        "past": {
          "one": "{0} վրկ առաջ",
          "other": "{0} վրկ առաջ"
        }
      },
      "week": {
        "-1": "նախորդ շաբաթ",
        "0": "այս շաբաթ",
        "1": "հաջորդ շաբաթ",
        "future": {
          "one": "{0} շաբաթից",
          "other": "{0} շաբաթից"
        },
        "past": {
          "one": "{0} շաբաթ առաջ",
          "other": "{0} շաբաթ առաջ"
        }
      },
      "week-narrow": {
        "-1": "նախորդ շաբաթ",
        "0": "այս շաբաթ",
        "1": "հաջորդ շաբաթ",
        "future": {
          "one": "{0} շաբ անց",
          "other": "{0} շաբ անց"
        },
        "past": {
          "one": "{0} շաբ առաջ",
          "other": "{0} շաբ առաջ"
        }
      },
      "week-short": {
        "-1": "նախորդ շաբաթ",
        "0": "այս շաբաթ",
        "1": "հաջորդ շաբաթ",
        "future": {
          "one": "{0} շաբ-ից",
          "other": "{0} շաբ-ից"
        },
        "past": {
          "one": "{0} շաբ առաջ",
          "other": "{0} շաբ առաջ"
        }
      },
      "year": {
        "-1": "նախորդ տարի",
        "0": "այս տարի",
        "1": "հաջորդ տարի",
        "future": {
          "one": "{0} տարուց",
          "other": "{0} տարուց"
        },
        "past": {
          "one": "{0} տարի առաջ",
          "other": "{0} տարի առաջ"
        }
      },
      "year-narrow": {
        "-1": "նախորդ տարի",
        "0": "այս տարի",
        "1": "հաջորդ տարի",
        "future": {
          "one": "{0} տարուց",
          "other": "{0} տարուց"
        },
        "past": {
          "one": "{0} տ առաջ",
          "other": "{0} տ առաջ"
        }
      },
      "year-short": {
        "-1": "նախորդ տարի",
        "0": "այս տարի",
        "1": "հաջորդ տարի",
        "future": {
          "one": "{0} տարուց",
          "other": "{0} տարուց"
        },
        "past": {
          "one": "{0} տ առաջ",
          "other": "{0} տ առաջ"
        }
      }
    },
    "locale": "hy"
  });
}